var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileNum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6663",
    "data-name": "Group 6663",
    transform: "translate(-832 -515)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2526",
    "data-name": "Rectangle 2526",
    width: 24,
    height: 24,
    transform: "translate(832 515)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "phone_2_",
    "data-name": "phone (2)",
    transform: "translate(832.273 515.273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5386",
    "data-name": "Group 5386",
    transform: "translate(1.725 1.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25603",
    "data-name": "Path 25603",
    d: "M20,16.119a2.959,2.959,0,0,0-.908-2.033,7.268,7.268,0,0,0-2.877-1.912,3.22,3.22,0,0,0-3.307.938l0,0-1.056,1.049a15.832,15.832,0,0,1-3.331-2.576l-.1-.1A15.833,15.833,0,0,1,5.839,8.156L6.887,7.1l0,0A3.22,3.22,0,0,0,7.83,3.788,7.268,7.268,0,0,0,5.919.911,2.973,2.973,0,0,0,1.792.762L1.77.782l-.03.029A6.34,6.34,0,0,0,0,5.455c.016,3.212,1.782,6.886,4.723,9.827A19.045,19.045,0,0,0,6.6,16.913a.781.781,0,0,0,.951-1.24,17.5,17.5,0,0,1-1.719-1.5c-2.657-2.657-4.251-5.92-4.265-8.73A4.827,4.827,0,0,1,2.83,1.93l.006-.005A1.406,1.406,0,0,1,4.794,2c2.023,2.1,1.876,3.088.983,4L4.328,7.46a.781.781,0,0,0-.159.868A15.789,15.789,0,0,0,7.31,12.592l.1.1a15.787,15.787,0,0,0,4.263,3.141.781.781,0,0,0,.868-.159L14,14.228c.917-.894,1.907-1.04,4,.983a1.406,1.406,0,0,1,.071,1.958l-.006.006a4.813,4.813,0,0,1-3.481,1.267h-.036a10.132,10.132,0,0,1-3.856-.913.781.781,0,0,0-.619,1.435A11.527,11.527,0,0,0,14.55,20h.044a6.326,6.326,0,0,0,4.6-1.739l.029-.03.02-.023A2.959,2.959,0,0,0,20,16.119Z",
    transform: "translate(0 -0.002)",
    fill: "#878a99"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileNum);
export default __webpack_public_path__ + "static/media/mobile-num.e38ee2d5e1497838ab3186168a73782c.svg";
export { ForwardRef as ReactComponent };